import {
    useMutation,
    useQueryClient,
    UseMutationResult,
} from '@tanstack/react-query'
import { IRule, IRuleSet } from '../../interfaces'
import { addRule } from '../../../../services/dtServices'

export const useCreateRule = (
    orgId: string,
    ruleSetId: string,
    entityId: string,
): UseMutationResult<Awaited<ReturnType<typeof addRule>>, Error, IRule> => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (rule: IRule) => {
            return addRule(orgId, ruleSetId, rule)
        },
        // client side optimistic update
        onMutate: (newRuleInfo: any) => {
            queryClient.setQueryData(
                ['rulesets', orgId, entityId],
                (ruleSets: any) =>
                    ruleSets?.data.map((ruleSet: IRuleSet) =>
                        ruleSet.id === ruleSetId
                            ? {
                                  ...ruleSet,
                                  rules: [...ruleSet.rules, newRuleInfo],
                              }
                            : ruleSet,
                    ),
            )
        },
        // refetch rules after mutation
        onSettled: () =>
            queryClient.invalidateQueries({
                queryKey: ['rulesets', orgId, entityId],
            }),
    })
}
